import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, formatApiErrorDetail } from '@/contexts/AuthContext';
import { LogIn, Leaf } from 'lucide-react';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      const status = err.response?.status;
      const detail = formatApiErrorDetail(err.response?.data?.detail);
      if (err.response) {
        // Server responded with an error status
        setError(detail !== 'Something went wrong. Please try again.'
          ? detail
          : `Login failed (HTTP ${status}). Please contact admin if this persists.`);
      } else if (err.request) {
        // Request was made but no response received
        setError('Cannot reach the server. Please check your internet connection.');
      } else {
        setError(err.message || 'Unexpected error. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen" style={{ backgroundColor: '#F9F6F0' }}>
      <div className="card p-8 w-full max-w-md" data-testid="login-form">
        <div className="text-center mb-8">
          <img
            src="https://customer-assets.emergentagent.com/job_jantikar-clinic/artifacts/b0xcrudr_logo.jpeg"
            alt="Jantikar Ayurveda"
            className="w-20 h-20 mx-auto mb-4 object-contain"
            data-testid="login-logo"
          />
          <h1 className="text-3xl font-bold" style={{ color: '#990099', fontFamily: 'Outfit, sans-serif' }}>
            Jantikar Ayurveda
          </h1>
          <p className="text-sm mt-2" style={{ color: '#6B7280' }}>Clinic Management System</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="admin@jantikar.com"
                data-testid="login-email-input"
                autoComplete="email"
              />
            </div>
            <div>
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
                data-testid="login-password-input"
                autoComplete="current-password"
              />
            </div>
          </div>

          {error && (
            <div className="mt-4 p-3 rounded-lg" style={{ backgroundColor: '#FEE2E2', color: '#991B1B' }} data-testid="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="primary-btn w-full mt-6 flex items-center justify-center gap-2"
            disabled={loading}
            style={{ opacity: loading ? 0.6 : 1 }}
            data-testid="login-submit-btn"
          >
            <LogIn size={20} />
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
